import { TRANSITION_MEDIUM } from '../constants/constants';
import { isMobileScreen, throttle } from '../Helper/helper';

document.addEventListener("DOMContentLoaded", function() {
	let isMobileDevice = isMobileScreen();

	window.addEventListener("resize", function() {
		isMobileDevice = isMobileScreen(); // Update isMobileDevice
	});

	var lastScrollTop = 0; // Variable to store the last scroll position

    // Function to update navigation links based on scroll position and direction
    function updateNavigation() {
		if (isMobileDevice) return;
        var scrollPosition = $(window).scrollTop();
        var windowHeight = $(window).height();
        var middleViewport = scrollPosition + windowHeight / 2;

        var currentActive = null;
        var scrollingDown = scrollPosition > lastScrollTop;

        $('.side-navigation__list-item').each(function() {
            var currentLink = $(this);
            var refElement = $(currentLink.attr("href"));
            var elementTop = refElement.offset().top;
            var elementHeight = refElement.outerHeight();
            var elementBottom = elementTop + elementHeight;

            if (scrollingDown) {
                // If scrolling down, activate when the top of the section hits the middle
                if (elementTop < middleViewport && elementBottom > middleViewport) {
                    currentActive = currentLink;
                }
            } else {
                // If scrolling up, activate when the bottom of the section leaves the middle
                if (elementBottom > middleViewport && elementTop < middleViewport) {
                    currentActive = currentLink;
                }
            }
        });

        if (currentActive) {
            $('.side-navigation__list-item').removeClass('active');
            currentActive.addClass('active');
        }
        lastScrollTop = scrollPosition; // Update the last scroll position
    }

	// Throttled function to handle scroll event
	var throttledUpdateNavigation = throttle(updateNavigation, 200);
	// Attach the throttled function to the window's scroll event
	$(window).on('scroll', throttledUpdateNavigation);
	// Call the function initially
	updateNavigation();
});
